
import create from 'zustand'
import { ResponseSolutions } from '../types/api'

interface StateApi {
  data: ResponseSolutions | {}
  fetchApi: () => Promise<void>;
}

declare global {
  interface Window {
    drupalSettings: any;
  }
}

// const urlApi = 'https://api-developpp.toroto.mx/api/aguasfirmes-landing';
// const urlApi = 'https://api-developpp-staging.toroto.mx/api/aguasfirmes-landing';



export const useApi = create((set: any) => ({
  data: {},
  fetchApi: async () => {
      const ds = window.drupalSettings.react.nodo

      const urlApi = ds.api_url ? ds.api_url : 'https://api-developpp.toroto.mx/api/aguasfirmes-landing';
      const tokenApi = ds.api_token ? ds.api_token  : "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2MmUwMzIzNDBjMTc2MTAwMmJmM2ZkOTMiLCJyb2xlIjoidXNlciIsImlhdCI6MTY1ODg2MDE5NX0.il2uVRhEXdPhwQZOhu5fRZAbhKWfV0fBPsaT7Q_gFsM";

      let myHeaders = new Headers();
      myHeaders.append("Authorization", tokenApi);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
      };
      const response = await fetch(urlApi, requestOptions)
      const dataApi = await response.json()
      console.log(urlApi)
      set({ data: dataApi })
  },
  fetchHome: async () => {
  
    let myHeaders = new Headers();
    myHeaders.append("Authorization", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2MmUwMzIzNDBjMTc2MTAwMmJmM2ZkOTMiLCJyb2xlIjoidXNlciIsImlhdCI6MTY1ODg2MDE5NX0.il2uVRhEXdPhwQZOhu5fRZAbhKWfV0fBPsaT7Q_gFsM");
  
    let requestOptions = {
      method: 'GET',
      headers: myHeaders,
    };
  
    const response = await fetch('https://api-developpp.toroto.mx/api/aguasfirmes-landing', requestOptions)
    const dataApi = await response.json()
    set({ data: dataApi })
  }
}))



    // const urlApi = 'https://api-developpp-staging.toroto.mx/api/aguasfirmes-landing'
    // const urlApi = location.protocol === 'http:'
    //     ? 'http://localhost:3005/api'
    //     : 'https://api-developpp-staging.toroto.mx/api/aguasfirmes-landing';
    // console.log(urlApi)